
// document.addEventListener("DOMContentLoaded", function () {
//   const MIN_CART_VALUE = 20000; // ₹200 in paise
//   const ALERT_ID = 'minimum-cart-alert-message';

//   function createOrGetAlertMessage(wrapper) {
//     let alert = wrapper.querySelector(`#${ALERT_ID}`);
//     if (!alert) {
//       alert = document.createElement('div');
//       alert.id = ALERT_ID;
//       alert.style.cssText = 'display: none; color: red; margin-top: 10px; font-weight: 500;';
//       alert.textContent = '❌ Minimum cart value should be ₹200 to proceed to checkout.';
//       const firstChild = wrapper.firstChild;
//     if (firstChild) {
//       wrapper.insertBefore(alert, firstChild);
//     } else {
//       wrapper.appendChild(alert);
//     }
//     }
//     return alert;
//   }

//   function checkMinimumCartValue() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         const checkoutButtons = document.querySelectorAll('[name="checkout"]');

//         checkoutButtons.forEach(button => {
//           // Ensure wrapper
//           let wrapper = button.closest('.checkout-button-wrapper');
//           if (!wrapper) {
//             wrapper = document.createElement('div');
//             wrapper.className = 'checkout-button-wrapper';
//             wrapper.style.width = '100%';
//             button.parentNode.insertBefore(wrapper, button);
//             wrapper.appendChild(button);
//           }

//           const alert = createOrGetAlertMessage(wrapper);

//           if (cart.total_price < MIN_CART_VALUE) {
//             button.setAttribute('disabled', 'true');
//             button.classList.add('checkout-disabled');
//             alert.style.display = 'block';
//           } else {
//             button.removeAttribute('disabled');
//             button.classList.remove('checkout-disabled');
//             alert.style.display = 'none';
//           }

//           // Only bind once
//           if (!button.hasAttribute('data-click-check')) {
//             button.setAttribute('data-click-check', 'true');

//             button.addEventListener('click', function (e) {
//               fetch('/cart.js')
//                 .then(res => res.json())
//                 .then(cart => {
//                   if (cart.total_price < MIN_CART_VALUE) {
//                     e.preventDefault();
//                     alert.style.display = 'block';
//                     button.setAttribute('disabled', 'true');
//                   } else {
//                     alert.style.display = 'none';
//                     const form = button.closest('form') || document.querySelector('form[action="/cart"]');
//                     if (form) form.submit();
//                   }
//                 });
//             });
//           }
//         });
//       });
//   }

//   // Run initially
//   checkMinimumCartValue();

//   // === 🔁 PATCH your existing AJAX cart functions ===
//   // 1. Intercept global AJAX cart update if possible
//   // (Try to run this inside your AJAX success callback after a quantity update)

//   const originalFetch = window.fetch;
//   window.fetch = async function (...args) {
//     const response = await originalFetch(...args);
//     const url = (args[0] && args[0].toString()) || '';

//     // If request is to /cart/change or /cart/update, check again after it completes
//     if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add')) {
//       response.clone().json().then(() => {
//         setTimeout(checkMinimumCartValue, 300); // Delay slightly to let DOM update
//       }).catch(() => {});
//     }

//     return response;
//   };

//   // 2. Optional: listen for DOM changes (backup for drawer or third-party updates)
//   const observer = new MutationObserver(() => {
//     setTimeout(checkMinimumCartValue, 300);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });
// });

document.addEventListener("DOMContentLoaded", function () {
  const MIN_CART_VALUE = 20000; // ₹200 in paise
  const ALERT_ID = 'minimum-cart-alert-message';

  function showAlert(button, show) {
    let alert = button.parentElement.querySelector(`#${ALERT_ID}`);

    if (!alert) {
      alert = document.createElement('div');
      alert.id = ALERT_ID;
      alert.style.cssText = 'color:red;margin-top:10px;font-weight:500;';
      alert.textContent = '❌ Minimum cart value should be ₹200 to proceed to checkout.';
      button.parentElement.appendChild(alert);
    }

    alert.style.display = show ? 'block' : 'none';
  }

  function updateButtons(cartTotal) {
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      if (cartTotal < MIN_CART_VALUE) {
        button.disabled = true;
        showAlert(button, true);
      } else {
        button.disabled = false;
        showAlert(button, false);
      }
    });
  }

  function checkCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateButtons(cart.total_price));
  }

  /* 🔒 Prevent click when disabled */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[name="checkout"]');
    if (btn && btn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* 🔁 Detect quantity changes (Ajax carts) */
  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="updates[]"]') ||
      e.target.closest('.quantity') ||
      e.target.closest('.cart__items')
    ) {
      setTimeout(checkCart, 400);
    }
  });

  /* 🔁 Backup: Mutation observer */
  const observer = new MutationObserver(() => {
    setTimeout(checkCart, 400);
  });
  observer.observe(document.querySelector('cart-items') || document.body, {
    childList: true,
    subtree: true
  });

  // Initial check
  checkCart();
});
